// extracted by mini-css-extract-plugin
export default {"postPageTagContainer":"Pc_no","tagLabel":"Nb7Qr","navigation":"_3nmW3"};